import { type ClassList, toClassListRecord, toClassName } from "@mdotm/shadcn/legacy/react-extensions";

export type SeparatorProps = {
	text?: string;
	align?: "center" | "start" | "end";
	className?: ClassList;
};

function Separator(props: SeparatorProps): React.JSX.Element {
	const { align = "center" } = props;
	return (
		<div
			className={toClassName({
				"relative flex py-2 items-center": true,
				[`text-[color:var(--palette-N200)]`]: true,
				...toClassListRecord(props.className),
			})}
		>
			<div
				className={toClassName({
					[`border-t border-[color:var(--palette-N200)]`]: true,
					grow: align === "center" || align === "end",
					"basis-[15%]": align === "start",
				})}
			/>
			{props.text && <span className="shrink mx-4 text-gray-400">{props.text}</span>}
			<div
				className={toClassName({
					[`border-t border-[color:var(--palette-N200)]`]: true,
					grow: align === "center" || align === "start",
					"basis-[15%]": align === "end",
				})}
			/>
		</div>
	);
}

export default Separator;
